import { Box, Button, FormControl, InputAdornment, MenuItem, OutlinedInput, Select, Skeleton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import InventoryStatistic from "../InventoryStaticstic";
import useInventoryAction from "./utils/useInventoryAction";
import useInventoryBody from "./utils/useInventoryBody";
import TabComp from "src/components/shared/TabComp";
import DateRangePicker from "src/components/shared/DateRangePicker";
import useInventoryTabs from "./utils/useInventoryTabs";
import useAuthGlobal from "src/context/useAuthGlobal";
import useInventoryReport from "src/hooks/inventory/useInventoryReport";
import { COMMOM_STATUS } from "src/constant";
import { enqueueSnackbar } from "notistack";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import appConfig from "src/config/env";
import ExportIcon from "src/components/shared/icon/ExportIcon";
import useWareHouseList from "src/hooks/warehouse/useWareHouseList";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
const topbarSearchList = [
  {
    id: 1,
    title: "Thương hiệu",
    value: "brand",
  },
  {
    id: 2,
    title: "Sản phẩm",
    value: "product",
  },
  {
    id: 3,
    title: "SKU",
    value: "sku",
  },
];

export default function InventoryTable() {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const [keyword, setKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const [prodId, setProdId] = useState();
  const [brand, setBrand] = useState();
  const [date, setDate] = useState();
  const [isExported, setIsExported] = useState(false);
  const [logId, setLogId] = useState();
  const [exportStarted, setExportStarted] = useState(false);
  const [warehouseId, setWarehouseId] = useState();
  const { tabs, isLoading: tabLoading } = useInventoryTabs();
  const action = useInventoryAction();

  const { error, isLoading, header, bodyList, sortData, pagi, setPagi, total } = useInventoryBody({ warehouseId, topbarSearchList, keyword, searchBy, date, prodId, brand });

  const { data: exportReport } = useInventoryReport(isExported ? date : undefined);
  const { mutate } = useProcessLogDetail(logId);
  const { data: warehouse } = useWareHouseList({ limit: 200, skip: 0 });

  const handleExportInventoryReport = () => {
    setIsExported((prev) => !prev);
  };

  useEffect(() => {
    if (isExported && !!exportReport?.data?.data?._id && !exportStarted) {
      setExportStarted(true);
      setLogId(exportReport.data.data._id);
      handleGetLog(exportReport.data.data._id);
      enqueueSnackbar("Tiến hành xuất báo cáo...", { variant: "success", className: "notistack-confirm" });
    }
    if (!isExported) {
      setExportStarted(false);
    }
  }, [exportReport?.data?.data?._id, exportStarted]);

  const handleGetLog = async (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const poll = async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            setLogId("");
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            return; // stop polling
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            return; // stop polling
          }
        }
        // Retry after 1 second
        setTimeout(poll, 1000);
      } catch (err) {
        console.error(err);
        // Retry after 1 second if needed
        setTimeout(poll, 1000);
      }
    };

    poll();
  };

  useEffect(() => {
    if (userMe?.currentWarehouse?._id) {
      setWarehouseId(userMe?.currentWarehouse?._id);
    }
  }, [userMe?.currentWarehouse?._id]);

  return (
    <>
      <PageHeader
        name="Quản lý Kho"
        subName="Tồn kho"
      />
      <InventoryStatistic whouseId={userMe?.currentWarehouse?._id} />
      {tabLoading ? <Skeleton width="100%" /> : <TabComp tabs={tabs} />}

      <Stack
        direction="row"
        justifyContent="space-between"
      >
        <Box
          m="12px 0 12px"
          display="flex"
          justifyContent="space-between"
          width="100%"
        >
          <Box
            display="flex"
            gap="6px"
            alignItems="flex-start"
          >
            <SearchFilterComp
              autoComplete={{
                brand: {
                  limit: 200,
                  skip: 0,
                  endpoint: "/api/v1/brands",
                  state: setBrand,
                  searchField: "name",
                },
                product: {
                  limit: 200,
                  skip: 0,
                  endpoint: "/api/v1/products",
                  state: setProdId,
                  searchField: "name",
                },
              }}
              getSearchKeyword={setKeyword}
              getSelectKeyword={setSearchBy}
              selectList={topbarSearchList}
            />
          </Box>
          <Box
            display="flex"
            gap={1}
          >
            {permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) && (
              <FormControl size="small">
                <Select
                  key={warehouseId}
                  value={warehouseId}
                  onChange={(e) => setWarehouseId(e.target.value)}
                  size="small"
                  labelId="warehouse-select-label"
                  input={
                    <OutlinedInput
                      startAdornment={
                        <InputAdornment position="start">
                          <Typography
                            fontWeight="bold"
                            sx={{
                              borderRight: "1px solid var(--grey)",
                              pr: "12px",
                              color: "var(--black)",
                              fontSize: "12px",
                            }}
                          >
                            Kho
                          </Typography>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {Array.isArray(warehouse?.data) ? (
                    warehouse?.data?.map((v) => {
                      return <MenuItem value={v?._id}>{v?.name}</MenuItem>;
                    })
                  ) : (
                    <MenuItem value={null}>Không tìm có dữ liệu</MenuItem>
                  )}
                </Select>
              </FormControl>
            )}

            <DateRangePicker
              value={date ?? { fromDate: null, toDate: null }}
              onApply={setDate}
              label="Tồn kho theo kỳ"
            />
            <Button
              onClick={handleExportInventoryReport}
              disabled={!date?.fromDate || !date?.toDate}
              variant="contained"
              startIcon={<ExportIcon />}
            >
              Xuất báo cáo
            </Button>
          </Box>
        </Box>
      </Stack>

      <TableComp
        pagi={pagi}
        setPagi={setPagi}
        total={total}
        action={action}
        bodyList={bodyList}
        sortData={sortData}
        headers={header}
        isLoading={isLoading}
        error={error}
      />
    </>
  );
}
